// Enum for ReportCenter Report IDs
export enum ReportCenterReports {
	// Explorer for JobOccupation Report
	JobOccupationExplorer = "6063ccaa-f3e8-4f75-b2fd-706d75e53edd",
	// JobOccupation Report FormReportId
	JobOccupationReport = "9603c8a6-c299-4f2d-9f9f-f2ddf80ccd7e"
}